export const ORDERS_REQUEST_DATA = {
    filters: [
        [{ column: 'STATUS', operator: 'eq', value: 'incorrect' }],
        [{ column: 'STATUS', operator: 'eq', value: 'productsNotAvailable' }],
    ],
    sorts: [{ column: 'ID', direction: 'DESC' }],
    page: 1,
    items: 1000,
    columns: ['ESHOP_ORDER_ID', 'ID', 'STATUS', 'INCORRECT_AT', 'TIMESTAMP'],
};

export const RECEIVING_REQUEST_DATA = {
    filters: [[{ column: 'STATUS', operator: 'eq', value: ['awaiting'] }]],
    sorts: [{ column: 'ID', direction: 'DESC' }],
    page: 1,
    items: 1000,
    columns: ['ESHOP_RECEIVING_ID', 'ID', 'STATUS', 'CREATED_AT', 'ESTIMATED_DELIVERY'],
};

export const TASKS_REQUEST_DATA = {
    filters: [],
    sorts: [{ column: 'ID', direction: 'DESC' }],
    page: 1,
    items: 1000,
    columns: ['ID', 'SECTION', 'JSON_DATA', 'TEXT', 'STATUS', 'CREATED_AT', 'CONFIRMED', 'CONFIRMED_AT'],
};

export const TASKS_GRID_URL = 'api/secure/tasks/grid';
